import React from "react";
import { Table } from "ant-table-extensions";
import FeatherIcon from "feather-icons-react";
import { useHistory } from "react-router-dom";
import { UserTableStyleWrapper } from "../../pages/style";
import { TableWrapper } from "../../styled";
import { Button } from "../../../components/buttons/buttons";
import { Cards } from "../../../components/cards/frame/cards-frame";
import { useTranslation } from "react-i18next";
import { exportujDoExcelu, odkazNaAdmin } from "../../../utils/exportExcel";
import { klikNaRiadok } from "../../../utils/klikNaRiadok";

const List = (props) => {
  const { t } = useTranslation("common");
  const { inputData, basePath } = props;
  const history = useHistory();
  const path = basePath || "/admin/car-owners";

  const tableData = [];

  inputData &&
    inputData.map((item) => {
      const {
        id,
        company,
        city,
        zip,
        ic,
        ic_dph,
        phone,
        invoice_emails,
        invoice_maturity,
        bonus,
        firstname,
        lastname,
      } = item;

      return tableData.push({
        id: id,
        key: id,
        company: company,
        city: city,
        ic: ic,
        icDph: ic_dph,
        phone: phone,
        zip: zip,
        invoiceEmail: invoice_emails,
        invoiceMaturity: invoice_maturity,
        bonus: bonus,
        firstname: firstname,
        lastname: lastname,
        // Cely riadok otvara upravu majitela. V akciach ostava len
        // odkaz na cely detail s jeho vozidlami a cennikom.
        action: (
          <div className="table-actions" onClick={(e) => e.stopPropagation()}>
            <Button
              onClick={() => history.push(`${path}/${id}`)}
              className="btn-icon"
              type="info"
              to="#"
              shape="circle"
              title="Detail s vozidlami a cenníkom"
            >
              <FeatherIcon icon="list" size={16} />
            </Button>
          </div>
        ),
      });
    });

  const handleDownload = () => {
    exportujDoExcelu({
      nazovSuboru: "majitelia",
      nazovHarku: "Majitelia",
      stlpce: [
        { kluc: "id", popis: "ID", sirka: 8, typ: "cislo" },
        { kluc: "firma", popis: "Firma", sirka: 34, typ: "odkaz" },
        { kluc: "mesto", popis: "Mesto", sirka: 20 },
        { kluc: "psc", popis: "PSČ", sirka: 10 },
        { kluc: "ico", popis: "IČO", sirka: 14 },
        { kluc: "icDph", popis: "IČ DPH", sirka: 16 },
        { kluc: "meno", popis: "Meno", sirka: 16 },
        { kluc: "priezvisko", popis: "Priezvisko", sirka: 18 },
        { kluc: "telefon", popis: "Telefón", sirka: 16 },
        { kluc: "fakturacnyMail", popis: "Fakturačný e-mail", sirka: 30 },
        { kluc: "splatnost", popis: "Splatnosť (dní)", sirka: 14, typ: "cislo" },
        { kluc: "zlava", popis: "Zľava (%)", sirka: 12, typ: "cislo" },
      ],
      riadky: (inputData || []).map((m) => ({
        id: m?.id,
        firma: {
          text: m?.company || "",
          url: odkazNaAdmin(`${path}/${m?.id}`),
        },
        mesto: m?.city,
        psc: m?.zip,
        ico: m?.ic,
        icDph: m?.ic_dph,
        meno: m?.firstname,
        priezvisko: m?.lastname,
        telefon: m?.phone,
        fakturacnyMail: m?.invoice_emails,
        splatnost: m?.invoice_maturity,
        zlava: m?.bonus,
      })),
      info: { Poznámka: "Export obsahuje to, čo je práve vyfiltrované v zozname." },
    });
  };

  return (
    <Cards headless>
      <UserTableStyleWrapper>
        <Button className="btn-export" onClick={handleDownload} type="primary">
          Export do Excelu
        </Button>
        <TableWrapper className="table-responsive">
          <Table
            scroll={{ x: "max-content" }}
            dataSource={tableData}
            columns={getTableColumns(t)}
            rowClassName={() => "riadok-klikatelny"}
            onRow={(record) =>
              klikNaRiadok({
                cesta: `${path}/${record.id}/edit`,
                akcia: () => history.push(`${path}/${record.id}/edit`),
              })
            }
            pagination={{
              defaultPageSize: 20,
              total: tableData.length,
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} ${t("common.from")} ${total} ${t(
                  "common.items"
                )}`,
            }}
          />
        </TableWrapper>
      </UserTableStyleWrapper>
    </Cards>
  );
};

const getTableColumns = t => {
  return [
    {
      title: t('carOwners.tableList.id'),
      dataIndex: 'id',
      key: 'id'
    },
    {
      title: t('carOwners.tableList.company'),
      dataIndex: 'company',
      key: 'company'
    },
    {
      title: t('carOwners.tableList.city'),
      dataIndex: 'city',
      key: 'city'
    },
    {
      title: t('carOwners.tableList.firstname'),
      dataIndex: 'firstname',
      key: 'firstname'
    },
    {
      title: t('carOwners.tableList.lastname'),
      dataIndex: 'lastname',
      key: 'lastname'
    },
    {
      title: t('carOwners.tableList.phone'),
      dataIndex: 'phone',
      key: 'phone'
    },
    {
      title: t('carOwners.tableList.invoiceEmail'),
      dataIndex: 'invoiceEmail',
      key: 'invoiceEmail'
    },
    {
      title: t('common.actions'),
      dataIndex: 'action',
      key: 'action',
      width: '90px'
    }
  ]
}

export default List
